import Vue from "vue";
import Hero from "./Hero.vue";
Vue.component("hero", Hero);
import Btn from "./Btn.vue";
Vue.component("abtn", Btn);
import InfoPanel from "./InfoPanel.vue";
Vue.component("info-panel", InfoPanel);
import Slider from "./Slider.vue";
Vue.component("slider", Slider);
import Accordion from "@/components/accordion/Accordion.vue";
Vue.component("accordion", Accordion);
import Content from "@/components/content/Content.vue";
Vue.component("content-block", Content);
import MediaLinksThumbs from "@/components/media/MediaLinksThumbs.vue";
Vue.component("media-links-thumbs", MediaLinksThumbs);
import MediaBoxes from "@/components/media/MediaBoxes.vue";
Vue.component("media-boxes", MediaBoxes);
import PanelGroup from "@/components/PanelGroup.vue";
Vue.component("panels", PanelGroup);
import List from "@/components/List.vue";
Vue.component("list", List);

import GridList from "@/components/grid/GridList.vue";
Vue.component("grid-list", GridList);

// Home Page Boxes
import Logo from "@/components/Logo.vue";
Vue.component("logo", Logo);

// Home Page Boxes
import HpBoxes from "@/components/HpBoxes.vue";
Vue.component("hp-boxes", HpBoxes);

// RAW HTML
import RawHtml from "@/components/RawHtml.vue";
Vue.component("raw-html", RawHtml);

// SHARE PAGE BUTTONS
import PageShare from "@/components/PageShare.vue";
Vue.component("page-share", PageShare);

// Publication List
import PublicationList from "@/components/PublicationList.vue";
Vue.component("publication-list", PublicationList);

// Publication Table
import PublicationTable from "@/components/PublicationTable.vue";
Vue.component("publication-table", PublicationTable);

// Profiles List
import ProfilesList from "@/components/ProfilesList.vue";
Vue.component("profiles-list", ProfilesList);

// CATEGORY LINKS
import CategoryBoxLinks from "@/components/CategoryBoxLinks.vue";
Vue.component("category-box-links", CategoryBoxLinks);

// CONTENT BOXES
import ContentBoxes from "@/components/content/ContentBoxes.vue";
Vue.component("content-boxes", ContentBoxes);

// PROFILE BOXES
import ProfileBoxes from "@/components/ProfileBoxes.vue";
Vue.component("profile-boxes", ProfileBoxes);

// MEDIA
import MediaArticles from "@/components/media/MediaArticles.vue";
Vue.component("media-articles", MediaArticles);
import MediaGallery from "@/components/media/MediaGallery.vue";
Vue.component("media-gallery", MediaGallery);
// import MediaSearchBar from "@/components/media/MediaSearchBar.vue";
// Vue.component("media-search-bar", MediaSearchBar);
import InnerSearch from "@/components/InnerSearch.vue";
Vue.component("inner-search", InnerSearch);

// CONTACT
import ContactMap from "@/components/contact/ContactMap.vue";
Vue.component("contact-map", ContactMap);
import ContactForm from "@/components/contact/ContactForm.vue";
Vue.component("contact-form", ContactForm);
import SearchList from "@/components/search/SearchList.vue";
Vue.component("search-list", SearchList);

/*
  Components for Events Module.
*/
import EventsList from "@/components/events/EventsList.vue";
Vue.component("events-list", EventsList);
import DatesPicker from "@/components/DatesPicker.vue";
Vue.component("dates-picker", DatesPicker);
import EventsFilters from "@/components/events/EventsFilters.vue";
Vue.component("events-filters", EventsFilters);
// TEMPORARY >> need to change *product-technical-info*
// to generic tab-group in admin
import TabGroup from "@/components/tab/TabGroup.vue";
Vue.component("product-technical-info", TabGroup);
import LinksList from "@/components/LinksList.vue";
Vue.component("links-list", LinksList);

import Preloader from "@/components/Preloader.vue";
Vue.component("preloader", Preloader);
